import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7534bbfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "category-type-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormFieldComboBox = _resolveComponent("FormFieldComboBox")!
  const _component_FormField = _resolveComponent("FormField")!
  const _component_FieldValue = _resolveComponent("FieldValue")!
  const _component_SwitchCategoryType = _resolveComponent("SwitchCategoryType")!
  const _component_FormFieldUrlAliasInput = _resolveComponent("FormFieldUrlAliasInput")!
  const _component_FormFieldFileInput = _resolveComponent("FormFieldFileInput")!
  const _component_FormFieldRichTextInput = _resolveComponent("FormFieldRichTextInput")!
  const _component_DynamicField = _resolveComponent("DynamicField")!
  const _component_ThroughNavigation = _resolveComponent("ThroughNavigation")!
  const _component_FilterTable = _resolveComponent("FilterTable")!
  const _component_ConditionPage = _resolveComponent("ConditionPage")!
  const _component_SeoFieldGroup = _resolveComponent("SeoFieldGroup")!
  const _component_FormFooter = _resolveComponent("FormFooter")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, {
    "tab-id": _ctx.selectedTabId,
    "onUpdate:tab-id": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedTabId) = $event)),
    title: _ctx.pageTitle,
    "is-content-loading": _ctx.isContentLoading,
    "header-buttons": _ctx.headerButtonList,
    tabs: _ctx.tabList
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_FormFooter, {
        "back-href": _ctx.backButtonUrl,
        "is-submitting": _ctx.isSubmitting || _ctx.isSwitchCategoryType,
        "is-creation": _ctx.isCreation,
        "can-create-another": _ctx.isCreation,
        onSubmit: _ctx.submitForm
      }, null, 8, ["back-href", "is-submitting", "is-creation", "can-create-another", "onSubmit"])
    ]),
    default: _withCtx(() => [
      (_ctx.isCreation)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            novalidate: "",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode(_component_FormFieldComboBox, {
              value: _ctx.values.type,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.type) = $event)),
              clearable: true,
              label: "Тип",
              error: _ctx.errors.type,
              name: "type",
              options: _ctx.typeOptionList
            }, null, 8, ["value", "error", "options"]),
            _createVNode(_component_FormField, {
              value: _ctx.values.name,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.values.name) = $event)),
              name: "name",
              error: _ctx.errors.name,
              label: "Название категории"
            }, null, 8, ["value", "error"]),
            _createVNode(_component_FormFieldComboBox, {
              value: _ctx.values.parent,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.values.parent) = $event)),
              label: "Родительская категория",
              error: _ctx.errors.parent,
              name: "type",
              options: _ctx.categoryListNoChildrenOption
            }, null, 8, ["value", "error", "options"])
          ], 32))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            novalidate: "",
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
          }, [
            (_ctx.selectedTabId === 'common')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_1, [
                    (_ctx.values.type)
                      ? (_openBlock(), _createBlock(_component_FieldValue, {
                          key: 0,
                          label: "Тип категории",
                          type: "text",
                          value: _ctx.values.type.label,
                          class: "category-type"
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true),
                    (_ctx.category && _ctx.category.availableToChangeType)
                      ? (_openBlock(), _createBlock(_component_SwitchCategoryType, {
                          key: 1,
                          "category-type": _ctx.category.type,
                          "handle-switch-category-type": _ctx.handleSwitchCategoryType,
                          "is-switch-category-type": _ctx.isSwitchCategoryType
                        }, null, 8, ["category-type", "handle-switch-category-type", "is-switch-category-type"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_FormField, {
                    value: _ctx.values.name,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.values.name) = $event)),
                    name: "name",
                    error: _ctx.errors.name,
                    label: "Название категории"
                  }, null, 8, ["value", "error"]),
                  _createVNode(_component_FormFieldComboBox, {
                    value: _ctx.values.parent,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.values.parent) = $event)),
                    label: "Родительская категория",
                    error: _ctx.errors.parent,
                    name: "type",
                    options: _ctx.categoryListNoChildrenOption
                  }, null, 8, ["value", "error", "options"]),
                  _createVNode(_component_FormFieldUrlAliasInput, {
                    id: "urlAlias",
                    value: _ctx.values.urlPath,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.values.urlPath) = $event)),
                    name: "urlPath",
                    label: "URL Path",
                    "url-template": _ctx.pagePath,
                    error: _ctx.errors.urlPath
                  }, null, 8, ["value", "url-template", "error"]),
                  _createVNode(_component_FormFieldFileInput, {
                    value: _ctx.values.image,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.values.image) = $event)),
                    label: "Картинка",
                    name: "image",
                    "file-type": "image"
                  }, null, 8, ["value"]),
                  _createVNode(_component_FormFieldRichTextInput, {
                    value: _ctx.values.content,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.values.content) = $event)),
                    name: "content",
                    label: "SEO Текст",
                    error: _ctx.errors.content
                  }, null, 8, ["value", "error"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'connections')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_DynamicField, {
                    field: _ctx.inputsCategoriesField,
                    "is-label-hidden": false
                  }, null, 8, ["field"]),
                  _createVNode(_component_ThroughNavigation, {
                    values: _ctx.values,
                    "category-option-list": _ctx.categoryOptionList
                  }, null, 8, ["values", "category-option-list"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'filters')
              ? (_openBlock(), _createBlock(_component_FilterTable, {
                  key: 2,
                  "field-option-list": _ctx.fieldOptionList,
                  filters: _ctx.values.filters
                }, null, 8, ["field-option-list", "filters"]))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'conditions')
              ? (_openBlock(), _createBlock(_component_ConditionPage, {
                  key: 3,
                  "is-label-hidden": false,
                  "product-type-option-list": _ctx.productTypeOptionList,
                  "brand-list-option": _ctx.brandListOption,
                  values: _ctx.values
                }, null, 8, ["product-type-option-list", "brand-list-option", "values"]))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'seo')
              ? (_openBlock(), _createBlock(_component_SeoFieldGroup, {
                  key: 4,
                  title: _ctx.values.pageTitle,
                  description: _ctx.values.pageDescription,
                  image: _ctx.values.openGraphImage,
                  onChange: _ctx.handleSearchEngineOptimization
                }, null, 8, ["title", "description", "image", "onChange"]))
              : _createCommentVNode("", true)
          ], 32))
    ]),
    _: 1
  }, 8, ["tab-id", "title", "is-content-loading", "header-buttons", "tabs"]))
}